/**
 * @file 無料登録
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangeRegister
 * @classdesc 無料登録
 */
export default class ChangeRegister {
	/**
	 * @constructor
	 * @param {jQuery} $e - [name=registration]
	 */
	constructor($e) {
		console.log('ChangeRegister.constructor');
		this._$e = $e;
		this._$wrap = $('.register-wrap');
		$e.on('click', () => this.onClick());
		this.onClick();
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeRegister
	 * @return {undefined}
	 */
	onClick() {
		console.log('ChangeRegister.onClick');
		if($('[name=registration]:checked').val() === '1'){
			this._$wrap.show().find('.validate').removeClass('ignore-validate');
		}else{
			Common.addIgnoreValidate(this._$wrap);
		}
	};
}
